import React from 'react';
import { Navigate, Outlet } from 'react-router-dom';
import { Box, CircularProgress } from '@mui/material';
import { useUserPermissions } from '../hooks/useUserPermissions';

interface DeliverablesTemplatesRouteProps {
  children?: React.ReactNode;
}

/**
 * Route guard for Deliverables Templates pages
 * Requires the user to have BOTH 'deliverables.all' AND 'deliverables.templates' permissions
 * Redirects to access denied if either permission is missing
 */
export const DeliverablesTemplatesRoute: React.FC<DeliverablesTemplatesRouteProps> = ({ children }) => {
  const { hasPermission, isLoading } = useUserPermissions();

  // Show loading while checking permissions
  if (isLoading) {
    return (
      <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', minHeight: '400px' }}>
        <CircularProgress />
      </Box>
    );
  }

  // Check for BOTH required permissions
  if (!hasPermission('deliverables.all') || !hasPermission('deliverables.templates')) {
    return <Navigate to="/access-denied" replace />;
  }

  return <>{children || <Outlet />}</>;
};
